import SpotifyPlayer from 'react-spotify-player'
import AnimatedHeading from './components/AnimatedHeading'
import './css/Label.css'
import { useLayoutEffect } from 'react'
import { gsap } from 'gsap'
import { useConsent } from './components/ConsentProvider'

function Label() {
    const { consent, openSettings } = useConsent()

    useLayoutEffect(() => {
        gsap.to('.spotify-wrap', {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: '.spotify-wrap',
                start: `top 80%`,
                toggleActions: 'play none none reverse',
                markers: false,
            },
        })
    })

    return (
        <>
            {/* <h1>Mag Records</h1>
            <AnimatedHeading lineOne={'New'} lineTwo={'Releases'} /> */}
            <AnimatedHeading lineOne={'Mag'} lineTwo={'Records'} />
            <h1 className='sub-heading'>New Releases</h1>
            <div className="spotify-wrap">
                {consent?.spotify ? (
                    <SpotifyPlayer
                        uri="https://open.spotify.com/playlist/7IMt8kJZeOsD3r5VVUOiSk?si=21359e333bcf405e"
                        size={{ width: '100%', height: '100%' }}
                        view="list"
                        theme="black"
                    />
                ) : (
                    <div className="spotify-placeholder">
                        <p className="spotify-placeholder__eyebrow">
                            Externer Inhalt
                        </p>
                        <h2>Spotify-Player ist deaktiviert</h2>
                        <p>
                            Der Player wird erst geladen, wenn Sie Spotify in den
                            Datenschutzeinstellungen erlauben.
                        </p>
                        <button onClick={openSettings} type="button">
                            Spotify erlauben
                        </button>
                        <a
                            href="https://open.spotify.com/playlist/7IMt8kJZeOsD3r5VVUOiSk"
                            rel="noreferrer"
                            target="_blank"
                        >
                            Direkt auf Spotify öffnen
                        </a>
                    </div>
                )}
            </div>
            <a id='schickUnsButton' href="mailto:info@mag-musik.de">
                schick uns deine Musik
            </a>
        </>
    )
}

export default Label
